export default __webpack_public_path__ + "static/media/e38fc2b4e220f706.90661754fd074620241f01cded0c07dc.svg";